<template lang="pug">
  figcaption.flex.type-caption.leading-wide.items-start.child-bold-text-gray-500(:class="{'min-h-36': !flush, 'pt-4 pb-16 md-pb-20': !noPadding, 'px-24': inset}")
    .flex-1 <slot></slot>
    .w-56.text-right.font-numbers-normal
      span(v-if="count && count[1] > 1") {{count[0] + 1}}&mdash;{{count[1]}}
</template>

<script>
export default {
  name: 'Media__Caption',
  props: ['flush', 'count', 'noPadding', 'inset']
}
</script>

<style>
</style>
